var _rect, _g, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4Kreis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "s4kreis",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_37",
    "data-name": "Rechteck 37",
    width: 150,
    height: 150,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_147",
    "data-name": "Gruppe 147",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 38.8,
    cy: 38.8,
    r: 38.8,
    transform: "translate(36.2 37.1)",
    fill: "#E20312"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_485",
    "data-name": "Pfad 485",
    d: "M75,42.6A33.2,33.2,0,1,1,41.8,75.8h0A33.375,33.375,0,0,1,75,42.6Zm0-5.5a38.8,38.8,0,1,0,38.8,38.8h0A38.709,38.709,0,0,0,75.182,37.1Z",
    fill: "#e30413"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_486",
    "data-name": "Pfad 486",
    d: "M45.6,81.8h6.8c.6,4.1,2.6,5.6,7.6,5.6,3.5,0,6.5-1.2,6.5-4.4s-3.2-3.8-8.2-5c-5.9-1.5-11.5-2.9-11.5-10,0-6.8,5.3-10,12.9-10s12.4,3.8,12.9,10.6H66.1c-.3-3.5-2.9-5-6.5-5s-6.2,1.5-6.2,3.8c0,2.6,2.4,3.5,7.4,4.7,7.1,1.5,12.6,3.2,12.6,10.3,0,6.8-5.6,10.6-13.2,10.6C50.9,92.9,45.9,88.8,45.6,81.8Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_487",
    "data-name": "Pfad 487",
    d: "M92.4,85.3h-15V78.2L92.1,59.4h6.5V80h5v5.3h-5v7.1H92.4ZM82.6,80h9.7V67.6h0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4Kreis);
export default __webpack_public_path__ + "static/media/s4kreis.cee18821d4f3a8c371ff83dba7201664.svg";
export { ForwardRef as ReactComponent };